







































































































































import settings from '@/settings'
import t from '@/utils/tools'
import vuescroll from 'vuescroll'

export default {
    name: 'menu_left'
    
    components: {
        vuescroll
    }

    watch:
        '$route': (to, from)->
            # console.log "WATCH ROUTE", to,
            if to.name in @company_informations_names
                @collaborateur_class = 'active'
            else
                @collaborateur_class = ''

        '$store.state.selected_company.uid': (value)->
            # console.log "WATCH selected_company", value
            if value == ''
                @disabled = true
            else
                @disabled = false

    data: ()->
        disabled: false
        left_sidebar_classes: ''
        company_informations_names: ['company_users_profile', 'company_users_vouchers', 'company_users_jobs', 'company_users_graduates', 'company_users_salaries', 'company_users_skills', 'company_users_pay_slips']
        collaborateur_class: ''
        ops: {
            bar: {
              background: '#404040',
              opacity: 0.4,
            },
        }
        # company_accesses: ['company_show','establishments_show','jobs_show','skills_show','recruitments_show','users_show',
        #                     'users_tree_show','absences_show','oncall_duties_show','formations_show',
        #                     'interviews_show','interview_campaigns_show','pro_hazards_show','elections_show']
        company_accesses: ['company_show','establishments_show','jobs_show','skills_show','recruitments_show','users_show',
                            'users_tree_show','absences_show','formations_show',
                            'interviews_show','interview_campaigns_show','pro_hazards_show','elections_show']
        informations_accesses: ['company_show','establishments_show','jobs_show','skills_show','recruitments_show']
        users_accesses: ['users_show', 'users_tree_show']
        # absences_accesses: ['absences_show','telework_show','oncall_duties_show']
        absences_accesses: ['absences_show','telework_show']
        formations_accesses: ['formations_show']
        interviews_accesses: ['interviews_show','interview_campaigns_show']
        pro_hazards_accesses: ['pro_hazards_show']
        elections_accesses: ['elections_show']
        vp_accesses: ['vpe_show']
        as_sync_accesses: ['edit_sync_params']
        profile_accesses: ['users_self_show','user_vouchers_self_show','users_jobs_self_show',
                            'user_salaries_self_show','graduates_self_show','users_skills_self_show',
                            'absences_self_edit','oncall_duties_self_show','formations_self_edit'
                            'pro_hazards_self_show','interviews_self_edit']
        profile_informations_accesses: ['users_self_show','user_vouchers_self_show','users_jobs_self_show',
                                'user_salaries_self_show','graduates_self_show','users_skills_self_show']
        # profile_absences_accesses: ['absences_self_edit','telework_self_edit','oncall_duties_self_show']
        profile_absences_accesses: ['absences_self_edit','telework_self_edit']
        profile_formations_accesses: ['formations_self_edit']
        # profile_pro_hazards_accesses: ['pro_hazards_show']
        profile_interviews_accesses: ['interviews_self_edit']
        profile_vp_accesses: ['vpe_self_show']
        tools_accesses: ['directory_show','events_show','files_show','manage_roles']
        imports_exports_accesses: ['balance_edit', 'establishments_edit', 'users_edit', 'user_salaries_edit', 'users_jobs_edit', 'exports_users_show']
        imports_accesses: ['balance_edit', 'establishments_edit', 'users_edit', 'user_salaries_edit', 'users_jobs_edit']

    methods:
        has_access_right: t.has_access_right
        absences_title: t.absences_title

        strap_clicked: ()->
            # console.log "LEFT SIDEBAR CLICKED"
            if @left_sidebar_classes == ''
                @left_sidebar_classes = 'open'
            else
                @left_sidebar_classes = ''

        can_see_menu: (accesses_array)->
            check = false
            for a in accesses_array
                if @has_access_right(a)
                    check = true
                    break
            return check

    mounted: ()->
        # console.log "MENU LEFT", @$route, @company_informations_names
        if @$route.name in @company_informations_names
            @collaborateur_class = 'active'
        else
            @collaborateur_class = ''
        if @$store.state.selected_company.uid == ''
            @disabled = true
        else
            @disabled = false

}
